package com.macrofocus.high_d.table

import emotion.react.css
import mui.x.GridFooter
import mui.x.GridToolbarColumnsButton
import react.FC
import react.Props
import react.ReactElement
import react.dom.html.ReactHTML.div
import web.cssom.Display
import web.cssom.JustifyContent
import web.cssom.px

external interface CustomFooterProps : Props {
    var filter: ReactElement<*>?
}

val CustomFooter = FC<CustomFooterProps> { props ->
    div {
        css {
            display = Display.flex
            justifyContent = JustifyContent.spaceBetween
            padding = 8.px
        }

        if (props.filter != null) {
            +props.filter!!
        }

        // Left: manage columns
        GridToolbarColumnsButton {}

        // Right: default footer
        GridFooter {}
    }
}